/* ------------------------------------------------------------------
   EXPOSITOR DE REGALO - Tierra Media

   El carrito lateral lo gestiona la app Xboost (no Horizon), que detecta
   los cambios espiando fetch/XHR y sondeando /cart.js. Por eso:
   - DETECTAR: MutationObserver del DOM + reconciliar contra /cart.js.
   - ESCRIBIR: window.fetch (para que Xboost lo vea y repinte).
   - LEER: fetch nativo (para no encadenar reconciliaciones).

   Reglas del carrito:
   - Si el banner tiene la casilla marcada y su producto esta dentro,
     anade sus expositores gratis (propiedad visible 'De regalo con').
   - Quita expositores huerfanos (sin su producto padre).
   - Fija la cantidad de cada expositor (no se puede subir).
   - CANDADO: un expositor anadido suelto (sin marca de regalo) se quita.
     Asi nadie consigue una caja gratis por el buscador o la URL.

   PAGO RAPIDO (1 oct 2026):
   - Mientras la casilla 'Anadir de regalo' esta marcada, se ocultan los
     botones de pago rapido (Shop Pay / Google Pay / Apple Pay / Comprar ya)
     de la ficha. Esos botones se saltan el carrito, asi que la caja no
     entraria en el pedido. Al desmarcar, vuelven a aparecer.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var fetchNativo = window.fetch.bind(window);

  var BANNER = '[data-expositor-banner]';
  var LINK = '_expositor_de';
  var LINK_PROD = '_expositor_de_prod';
  var GIFT = '_expositor_regalo';
  var QTY = '_expositor_qty';
  var ETIQUETA = 'De regalo con';

  // Variantes de los 3 expositores. Nunca deben estar en el carrito sin
  // la marca de regalo (ya no se venden sueltos).
  var EXPO = { '55592150532471': 1, '55592149057911': 1, '55592149090679': 1 };

  var trabajando = false;
  var pendiente = false;
  var ultimaVez = 0;
  var temporizador = null;
  var MIN_MS = 600;

  /* ---------- Pago rapido: oculto mientras la caja esta marcada ---------- */
  var CLASE_SIN_PAGO_RAPIDO = 'tm-caja-marcada';
  (function estilosPagoRapido() {
    try {
      var st = document.createElement('style');
      st.setAttribute('data-tm-pago-rapido', '');
      st.textContent =
        'html.' + CLASE_SIN_PAGO_RAPIDO + ' .accelerated-checkout-block,' +
        'html.' + CLASE_SIN_PAGO_RAPIDO + ' .shopify-payment-button,' +
        'html.' + CLASE_SIN_PAGO_RAPIDO + ' shopify-accelerated-checkout,' +
        'html.' + CLASE_SIN_PAGO_RAPIDO + ' [data-shopify="payment-button"]' +
        '{display:none !important;}';
      (document.head || document.documentElement).appendChild(st);
    } catch (e) {}
  })();

  function sincronizarPagoRapido() {
    var marcada = false;
    var checks = document.querySelectorAll(BANNER + ' [data-expositor-check]');
    for (var i = 0; i < checks.length; i++) if (checks[i].checked) { marcada = true; break; }
    document.documentElement.classList.toggle(CLASE_SIN_PAGO_RAPIDO, marcada);
  }

  function leerCarrito() {
    return fetchNativo('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r || !r.ok) return null;
        var t = r.headers.get('content-type') || '';
        if (t.indexOf('json') === -1 && t.indexOf('javascript') === -1) return null;
        return r.json().catch(function () { return null; });
      });
  }

  function escribir(url, body) {
    return window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
  }

  function getBanner() {
    var el = document.querySelector(BANNER);
    if (!el) return null;
    var check = el.querySelector('[data-expositor-check]');
    var expos = (el.getAttribute('data-expositores') || '')
      .split(',').filter(Boolean).map(function (par) {
        var t = par.split(':');
        return { id: Number(t[0]), qty: Number(t[1]) || 1 };
      }).filter(function (x) { return x.id; });
    return {
      el: el,
      prod: String(el.getAttribute('data-producto') || ''),
      checked: !!(check && check.checked),
      quitarIntencion: el.dataset.quitarRegalo === '1',
      expositores: expos
    };
  }

  /* ---------- Estado visual del selector ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest && e.target.closest('[data-expositor-check]');
    if (!input) return;
    var banner = input.closest(BANNER);
    if (!banner) return;

    banner.classList.toggle('expositor-activo', input.checked);
    if (input.checked) delete banner.dataset.quitarRegalo;
    else banner.dataset.quitarRegalo = '1';

    var badge = banner.querySelector('[data-badge]');
    if (badge) badge.textContent = input.checked ? badge.dataset.on : badge.dataset.off;
    var etiqueta = banner.querySelector('.expositor-check .etiqueta');
    if (etiqueta) etiqueta.textContent = input.checked ? etiqueta.dataset.on : etiqueta.dataset.off;

    sincronizarPagoRapido();
    programar(50);
  });

  /* ---------- Reconciliacion ---------- */
  function programar(retraso) {
    clearTimeout(temporizador);
    temporizador = setTimeout(reconciliar, retraso == null ? 350 : retraso);
  }

  function reconciliar() {
    if (trabajando) { pendiente = true; return; }
    var desde = Date.now() - ultimaVez;
    if (desde < MIN_MS) { programar(MIN_MS - desde); return; }

    trabajando = true;
    ultimaVez = Date.now();

    leerCarrito()
      .then(function (cart) {
        if (!cart || !cart.items) return null;

        var varPres = {}, prodPres = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p[GIFT]) return;
          varPres[String(it.variant_id)] = true;
          prodPres[String(it.product_id)] = true;
        });

        var cambios = [];

        // CANDADO: expositor suelto (sin marca de regalo) -> fuera
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (EXPO[String(it.variant_id)] && !p[GIFT]) cambios.push({ key: it.key, quantity: 0 });
        });

        var gifts = cart.items.filter(function (it) { return (it.properties || {})[GIFT]; });
        gifts.forEach(function (it) {
          var p = it.properties || {};
          var tienePadre =
            (p[LINK] && varPres[String(p[LINK])]) ||
            (p[LINK_PROD] && prodPres[String(p[LINK_PROD])]);
          if (!tienePadre) { cambios.push({ key: it.key, quantity: 0 }); return; }
          var esperado = parseInt(p[QTY], 10);
          if (esperado > 0 && it.quantity !== esperado) cambios.push({ key: it.key, quantity: esperado });
        });

        var b = getBanner();
        var anadir = [];
        if (b && b.prod) {
          var padre = null;
          cart.items.forEach(function (it) {
            if (String(it.product_id) === b.prod && !(it.properties || {})[GIFT]) padre = it;
          });
          var giftsProd = gifts.filter(function (it) {
            return String((it.properties || {})[LINK_PROD]) === b.prod;
          });

          if (b.checked && padre) {
            b.expositores.forEach(function (x) {
              var ya = giftsProd.some(function (it) {
                var borrada = cambios.some(function (c) { return c.key === it.key && c.quantity === 0; });
                return String(it.variant_id) === String(x.id) && !borrada;
              });
              if (!ya) anadir.push({ id: x.id, qty: x.qty, padreVar: padre.variant_id, nombre: padre.product_title || '' });
            });
          } else if (!b.checked && b.quitarIntencion) {
            giftsProd.forEach(function (it) {
              if (!cambios.some(function (c) { return c.key === it.key; })) {
                cambios.push({ key: it.key, quantity: 0 });
              }
            });
          }
        }

        if (!cambios.length && !anadir.length) return null;
        return aplicar(cambios, anadir, b);
      })
      .catch(function () { return null; })
      .then(function (huboCambio) {
        trabajando = false;
        if (huboCambio) { try { sessionStorage.setItem('tm_expo', '1'); } catch (e) {} notificar(); }
        if (pendiente) { pendiente = false; programar(300); }
      });
  }

  function aplicar(cambios, anadir, b) {
    var cadena = Promise.resolve();
    cambios.forEach(function (c) {
      cadena = cadena.then(function () { return escribir('/cart/change.js', { id: c.key, quantity: c.quantity }); });
    });
    if (anadir.length && b) {
      cadena = cadena.then(function () {
        return escribir('/cart/add.js', {
          items: anadir.map(function (a) {
            var props = {};
            props[LINK] = String(a.padreVar);
            props[LINK_PROD] = b.prod;
            props[GIFT] = 'true';
            props[QTY] = String(a.qty);
            if (a.nombre) props[ETIQUETA] = a.nombre;
            return { id: a.id, quantity: a.qty, properties: props };
          })
        });
      });
    }
    return cadena.then(function () { return true; });
  }

  function notificar() {
    var comp = document.querySelector('cart-items-component');
    if (comp && typeof comp.fetchCartData === 'function') {
      try { comp.fetchCartData(); } catch (e) {}
    }
    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (n) {
      try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
    });
  }

  /* ---------- Disparadores ---------- */
  function pareceCarrito(node) {
    if (!node || node.nodeType !== 1) return false;
    var s = (node.tagName + ' ' + (node.className || '') + ' ' + (node.id || '')).toLowerCase();
    return s.indexOf('cart') !== -1 || s.indexOf('xboost') !== -1 || s.indexOf('xb-') !== -1;
  }

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (pareceCarrito(m.target)) { programar(); return; }
      for (var j = 0; j < m.addedNodes.length; j++) if (pareceCarrito(m.addedNodes[j])) { programar(); return; }
      for (var k = 0; k < m.removedNodes.length; k++) if (pareceCarrito(m.removedNodes[k])) { programar(); return; }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  try {
    var f = window.fetch;
    window.fetch = function (e) {
      var u = ''; try { u = typeof e === 'string' ? e : (e && e.url) || ''; } catch (x) {}
      var pr = f.apply(this, arguments);
      if (u && u.indexOf('/cart/add') !== -1) pr.then(function () { programar(); }).catch(function () {});
      return pr;
    };
    var xo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      if (u && String(u).indexOf('/cart/add') !== -1) this.addEventListener('load', function () { programar(); });
      return xo.apply(this, arguments);
    };
  } catch (e) {}

  /* ---------- Zoom de la imagen ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-expositor-zoom]')) {
      var dlg = document.querySelector('[data-expositor-dialog]');
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      return;
    }
    var cerrar = t.closest('[data-expositor-cerrar]');
    if (cerrar) { var d = cerrar.closest('dialog'); if (d) d.close(); return; }
    if (t.matches && t.matches('[data-expositor-dialog]')) t.close();
  });

  /* ---------- Arranque ---------- */
  function inicio() {
    sincronizarPagoRapido();
    var hayBanner = !!document.querySelector(BANNER);
    var enCart = window.location.pathname.indexOf('/cart') === 0;
    var marca = false; try { marca = sessionStorage.getItem('tm_expo') === '1'; } catch (e) {}
    if (hayBanner || enCart || marca) programar(700);
  }

  // Al volver atras (bfcache) el navegador puede restaurar la casilla marcada
  window.addEventListener('pageshow', sincronizarPagoRapido);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicio);
  } else {
    inicio();
  }
})();
